import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Module23Survey {
  constructor() {
    let cache = {};
    let disabled = true;
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.surveyOptions = document.querySelectorAll('.module-23_survey .survey .option');
      cache.surveyBtn = document.querySelectorAll('.module-23_survey .btn_search');
    };

    let registerEvents = () => {
        for (let i = 0; i < cache.surveyOptions.length; i++) {
            cache.surveyOptions[i].addEventListener('click',surveyOptions);
        }
        for (let i = 0; i < cache.surveyBtn.length; i++) {
            cache.surveyBtn[i].addEventListener('click',survey);
        }
    };

    let surveyOptions = function() {
       const parent = this.closest('.option_wrap');
       const container = parent.closest('.survey');
       const currentActive = parent.querySelector('.option.active');
       const search = container.querySelector('.btn_search');
       this.classList.add('active');
       if(currentActive) {
           currentActive.classList.remove('active');
       }

       if(search.classList.contains('disabled') && (container.querySelectorAll('.option.active').length == 3)) {
            search.classList.remove('disabled');
       }
    }

    let survey = function() {
        const parent = this.closest('.survey_container');
        const options = parent.querySelectorAll('.option.active');
        const a1 = options[0].dataset.value;
        const a2 = options[1].dataset.value;
        const a3 = options[2].dataset.value;
        const squares = parent.querySelectorAll('.square');
        const active_img = parent.querySelector('.result .active');
        const talk_to_us = parent.querySelector('.talk_to_us');
        const result_box = parent.querySelector('.result_box');

        for (let i = 0; i < squares.length; i++) {
            anime({
                targets: squares[i],
                duration: 400,
                scale: [0.8, 1],
                opacity: [0, 1],
                delay: 50 * i,
                easing: 'easeInOutCubic',
            });
        }

        anime({
            targets: active_img,
            duration: 600,
            opacity: [1, 0],
            scale: [1, 0.8],
            easing: 'easeInOutCubic',
            complete: function() {
                active_img.classList.remove('active');
                active_img.style.display = 'none';
                if( (a1 == "no_value") || (a2 == "no_value") || (a3 == "no_value")) {
                    talk_to_us.style.display = 'flex';
                    talk_to_us.classList.add('active');
                    if(globalVar.mobile.matches) {
                        anime({
                            targets: globalVar.scrollElement,
                            duration: 600,
                            scrollTop: parent.querySelector('.result_container').offsetTop,
                            easing: 'easeInOutCubic',
                        });
                    }
                    anime({
                        targets: talk_to_us,
                        duration: 600,
                        opacity: [0, 1],
                        scale: [0.8,1],
                        delay: 300,
                        easing: 'easeInOutCubic',
                    });
                } else {
                    const nbGpu = parseInt(a1);
                    let price_step2 = 0; 
                    let price_step3 = 0; 
                    if(a2) {
                        price_step2 = (nbGpu * parseInt(a2)); 
                    }
                    if(a3) {
                        price_step3 = (nbGpu * parseInt(a3)); 
                    }

                    const price = price_step2 + price_step3;
                    result_box.querySelector('.price').innerHTML = price;
                    result_box.style.display = 'flex';
                    result_box.classList.add('active');
                    if(globalVar.mobile.matches) {
                        anime({
                            targets: globalVar.scrollElement,
                            duration: 600,
                            scrollTop: parent.querySelector('.result_container').offsetTop,
                            easing: 'easeInOutCubic',
                        });
                    }
                    anime({
                        targets: result_box,
                        duration: 600,
                        opacity: [0, 1],
                        scale: [0.8,1],
                        delay: 300,
                        easing: 'easeInOutCubic',
                    });
                }
            }
        });
    }

    initFunc();
  };
}
export { Module23Survey }